import React from 'react';
import { GenericFilterHeader } from '../../../components/requests/components/filter-columns/GenericFilterHeader';
import { PropagationStopper } from '../../../components/common';

interface SurveyScopeHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
    readonly filterOptions: string[];
    readonly loading?: boolean;
}

export function SurveyScopeHeader({
    currentValue,
    onChange,
    filterOptions,
    loading,
}: SurveyScopeHeaderProps) {
    return (
        <PropagationStopper>
            <GenericFilterHeader
                label="Adzone/StoreNo"
                filterOptions={filterOptions}
                currentValue={currentValue}
                onChange={onChange}
                loading={loading}
            />
        </PropagationStopper>
    );
}
